<template>
  <div>
    <div v-if="searchActive== true">
      <div class="lds-dual-ring"></div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-4">
          <p-button outline type="info" size="sm" round @click="$router.go(-1)">
            <i class="fa fa-chevron-circle-left"></i>
            Back
          </p-button>
        </div>
      </div>
      <div>
        <form ref="searchForm" @submit.prevent="searchSubmit">
          <div>
            <div>
              <fg-input
                label="Enter Instagram Profile"
                single-line
                solo
                :value="instagramProfile"
                v-model="profileSearch"
                v-on:keyup.enter="searchSubmit"
              ></fg-input>
            </div>
            <div>
              <p-button @click.prevent="searchSubmit">SEARCH</p-button>
            </div>
          </div>
        </form>
      </div>
      <div v-if="profile !== null" class="row">
        <div class="col-12">
          <div class="card card-user">
            <div class="image" style></div>
            <div class="card-body">
              <div class="author">
                <a :href="'https://instagram.com/'+profile.profileName" target="_blank">
                  <img
                    class="avatar border-gray"
                    :src="profile.profilePic"
                    @error="profilePicLoadCache(profile.profileName)"
                    alt="..."
                  />
                  <h5 class="title">@{{profile.profileName}}</h5>
                </a>
                <p class="description" style="display:none;"></p>
              </div>
              <p
                class="description text-center"
                v-if="typeof profile.bio !== 'undefined'"
              >{{profile.bio}}</p>
            </div>
            <div v-if="typeof profile.website !== 'undefined'" style="text-align:center;">
              <p>
                <strong>Website:</strong>
              </p>

              <a :href="profile.website" target="_blank">{{profile.website}}</a>
            </div>
            <div v-if="typeof profile.email !== 'undefined'" style="text-align:center;">
              <p>
                <strong>Email:</strong>
              </p>
              {{ profile.email }}
            </div>
            <div class="card-footer">
              <hr />
              <div class="button-container">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-6 col-6 ml-auto"
                    v-if="typeof profile.followerCount !== 'undefined'"
                  >
                    <h5>
                      {{profile.followerCount}}
                      <br />
                      <small>Followers</small>
                    </h5>
                  </div>
                  <div
                    class="col-lg-4 col-md-6 col-6 ml-auto mr-auto"
                    v-if="typeof profile.engagementRate!== 'undefined'"
                  >
                    <h5>
                      {{ (profile.engagementRate * 100).toFixed(2) }}%
                      <br />
                      <small>ER</small>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-8 col-md-7" style="display:none;"></div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import { loadInstagramProfile, instagramProfileCacheApi } from "@/config/appSettings";
export default {
  data: () => ({
    loadingOverlay: false,
    profile: null,
    instagramProfile: null,
    profileSearch: null,
    searchActive: false,
  }),
  name: "InstagramDetail",
  methods: {
    async searchSubmit() {
      if (this.profileSearch !== null) {
        if (this.profileSearch !== this.$route.query.instagram) {
          this.$router.push({
            query: { instagram: this.profileSearch },
          });
        }
      }
      console.log("LOADING PROFILE:", this.$route.query.instagram);

      try {
        if (
          this.$route.query.instagram !== null &&
          this.$route.query.instagram.trim() !== "" &&
          typeof this.$route.query.instagram !== "undefined"
        ) {
          this.instagramProfile = this.$route.query.instagram;
          if (
            this.profileSearch === null ||
            this.profileSearch.trim() !== "" ||
            typeof profileSearch !== "undefined"
          ) {
            this.profileSearch = this.instagramProfile;
          }
        }

        this.loadProfile();
      } catch (err) {
        console.log(err);
      }
    },
    async loadProfile() {
      let userToken = firebase.auth().currentUser.uid;
      console.log("LOADING PROFILE SEARCH:", this.profileSearch);
      this.searchActive = true;
      try {
        if (
          this.profileSearch !== null &&
          this.profileSearch.trim() !== "" &&
          this.profileSearch !== "undefined"
        ) {
          let profileDetail = await axios.get(
            `${loadInstagramProfile}/?usertoken=${userToken}&instagram=${this.profileSearch}`
          );

          if (profileDetail.data.success === true) {
            this.searchActive = false;
            this.profile = profileDetail.data.result;
          }
        }
      } catch (err) {}
    },
    async profilePicLoadCache(instagramProfile) {
      try {
        let profileCacheUrl = `${instagramProfileCacheApi}/?usertoken=${this.auth}&instagram=${instagramProfile}`;
        console.log("PROFILE CACHE:", profileCacheUrl);
        let profileCacheResponse = await axios.get(profileCacheUrl);
        console.log(`LOADING ${instagramProfile}`, profileCacheResponse.data);
      } catch (err) {
        console.log("ERR", err);
      }
    },
  },

  mounted() {
    this.searchSubmit();
  },
};
</script>

<style scoped>
</style>